import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { COMMON_STANDALONE_IMPORTS } from '@shared/common-imports';
import { LoaderComponent } from '@shared/components';

@Component({
  selector: 'app-auth-card',
  templateUrl: './auth-card.component.html',
  imports: [...COMMON_STANDALONE_IMPORTS, LoaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block w-[34rem] max-w-full' },
})
export class AuthCardComponent {
  readonly loader = input.required<string>();
  readonly title = input.required<string>();
  readonly description = input<string>();
}
